import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { File, UploadStatus } from "../../types/app";

export interface MainState {
  loading: boolean;
  snackbarOpen: boolean;
  snackbarStatus: UploadStatus;
  snackbarMessage: string;
  landingDialogOpen: boolean;
  fetchHistoricalQueryLoading: boolean;
  queryDrawerOpen: boolean;
  viewQuery: string[];
  viewPage: number;
  files: File[];
}

const initialState: MainState = {
  loading: true,
  snackbarOpen: false,
  snackbarStatus: undefined,
  snackbarMessage: "",
  landingDialogOpen: false,
  fetchHistoricalQueryLoading: false,
  queryDrawerOpen: false,
  viewQuery: [],
  viewPage: 0,
  files: [],
};

export const mainResetAll = createAction("RESET_ALL");

export const mainSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setLoaded: (state) => {
      state.loading = false;
    },
    setSnackbarState: (state, action: PayloadAction<boolean>) => {
      state.snackbarOpen = action.payload;
    },
    setSnackbarStatus: (state, action: PayloadAction<UploadStatus>) => {
      state.snackbarStatus = action.payload;
    },
    setSnackbarMessage: (state, action: PayloadAction<string>) => {
      state.snackbarMessage = action.payload;
    },
    setLandingDialogState: (state, action: PayloadAction<boolean>) => {
      state.landingDialogOpen = action.payload;
    },
    setFetchHistoricalQueryState: (state, action: PayloadAction<boolean>) => {
      state.fetchHistoricalQueryLoading = action.payload;
    },
    setQueryDrawerState: (state, action: PayloadAction<boolean>) => {
      state.queryDrawerOpen = action.payload;
    },
    setViewQuery: (state, action: PayloadAction<string[]>) => {
      state.viewQuery = action.payload;
    },
    setViewPage: (state, action: PayloadAction<number>) => {
      state.viewPage = action.payload;
    },
    setFiles: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload.sort((a: File, b: File) =>
        a.fileName.localeCompare(b.fileName)
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(mainResetAll, () => initialState);
  },
});

export const {
  setLoaded,
  setSnackbarState,
  setSnackbarStatus,
  setSnackbarMessage,
  setLandingDialogState,
  setFetchHistoricalQueryState,
  setQueryDrawerState,
  setViewQuery,
  setViewPage,
  setFiles,
} = mainSlice.actions;

export default mainSlice.reducer;
